import fetch from '@/utils/fetch'
export default {
  questionSave (params) {
    return fetch({
      url: '/wechat/questionnaire/save',
      method: 'post',
      params
    })
  },
  ecodePage (params) {
    return fetch({
      url: '/wechat/activity/ecode/page',
      method: 'post',
      params
    })
  },
  sendSms (params) {
    return fetch({
      url: '/wechat/activity/ecode/sms_send',
      method: 'post',
      params
    })
  },
  ecodeDraw (params) {
    return fetch({
      url: '/wechat/activity/ecode/draw',
      method: 'post',
      params
    })
  },
//   根据经纬度获取城市信息
cityByLocation (params) {
    return fetch({
      url: '/wechat/city/by/location',
      method: 'post',
      params
    })
  },
//   获取门店列表
shopQueryList (params) {
    return fetch({
      url: '/wechat/shop/query/list',
      method: 'post',
      params
    })
  },
//   获取城市列表
cityQueryList (params) {
    return fetch({
      url: '/wechat/city/query/list',
      method: 'post',
      params
    })
  },
}  